import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import ProfileContentLoader from '@/shared-components/loader/special-loaders/ProfileContentLoader';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableThoughts } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function Thoughts({ profileData, internal }) {
  const t = useTranslations('common.profile.pages.community');
  const { loading, fetchData, setFetchData, loadMoreData } = useCache(
    `${profileData._id}_thoughts`,
    `${config.apis.api.url}/thought/user/${profileData._id}`,
    {
      injectToken: true,
      invalidateWhen: internal
        ? ["NEW_THOUGHT", "DELETE_THOUGHT", `${profileData._id}_REFRESH`]
        : [`${profileData._id}_REFRESH`],
    }
  );
  const visibleThoughts = filterRenderableThoughts(fetchData?.data);

  if (loading) { 
    return (
      <div className="profile-community-thoughts-loader-container">
        <ProfileContentLoader />
      </div>
    );
  } else {
    return (
      <>
        {visibleThoughts.length === 0 ? (
          <Text
            className="profile-community-thoughts__empty-text font-size-medium"
            paragraph>
            {internal 
              ? t('empty.thoughts_internal')
              : t('empty.thoughts_external')}
          </Text>
        ) : (
          <VirtualList 
            items={fetchData} 
            visibleItems={visibleThoughts}
            setItems={setFetchData} 
            onLoadMore={loadMoreData} 
            cacheKey={`${profileData._id}_thoughts`}
          />
        )}
      </>
    );
  }
}
